import { TuVantageScore3Buckets } from '@generated-gql/generated-types';
// The first segment (poor credit) is given 1/2 of the meter.
const FIFTY_PCT = 50;
// The remaining three sections each get 1/6 of the meter.
const THIRD_OF_FIFTY_PCT = 50 / 3;

export const TierRanges = {
  [TuVantageScore3Buckets.Poor]: {
    min: 300,
    max: 629,
  },
  [TuVantageScore3Buckets.Average]: {
    min: 630,
    max: 689,
  },
  [TuVantageScore3Buckets.Good]: {
    min: 690,
    max: 719,
  },
  [TuVantageScore3Buckets.Excellent]: {
    min: 720,
    max: 880, // The max user score should be 850 - however, this value is to prevent potential text overflow
  },
};

export const HORIZONTAL_GAUGE_WIDTHS = {
  [TuVantageScore3Buckets.Poor]: {
    start: 0,
    percentageOfTotal: FIFTY_PCT,
  },
  [TuVantageScore3Buckets.Average]: {
    start: FIFTY_PCT,
    percentageOfTotal: THIRD_OF_FIFTY_PCT,
  },
  [TuVantageScore3Buckets.Good]: {
    start: FIFTY_PCT + THIRD_OF_FIFTY_PCT,
    percentageOfTotal: THIRD_OF_FIFTY_PCT,
  },
  [TuVantageScore3Buckets.Excellent]: {
    start: FIFTY_PCT + 2 * THIRD_OF_FIFTY_PCT,
    percentageOfTotal: THIRD_OF_FIFTY_PCT,
  },
};
